import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import styled from "styled-components"; //eslint-disable-line
import { css } from "styled-components/macro"; //eslint-disable-line
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnDark";
import MainFeature1 from "components/features/TwoColWithButton.js";
// import MainFeature2 from "components/features/TwoColSingleFeatureWithStats.js";
// import MainFeature3 from "components/features/TwoColSingleFeatureWithStats2.js";
import Features from "components/features/ThreeColSimple.js";
// import Features from "components/features/ThreeColWithSideImage.js";
import TeamCardGrid from "components/cards/ProfileThreeColGrid.js";

import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomerLoveIconImage from "images/simple-icon.svg";
import DashedBorderSixFeatures from "components/features/DashedBorderSixFeatures";
import TwoColSingleFeatureWithStats from "components/features/TwoColSingleFeatureWithStats";
import TwoColumnWithVideo from "components/hero/TwoColumnWithVideo";
import Healthcare from "../../images/healthcare1.jpeg"
import Healthcare2 from "../../images/healthcare2-removebg-preview.png"
import Healthcare4 from "../../images/healthcare4.jpg"

import ContactUs from "pages/ContactUs";
import TwoColContactUsWithIllustrationFullForm from "components/forms/TwoColContactUsWithIllustrationFullForm";
import GetStarted from "components/cta/GetStarted";
import SEO from "components/SEO";

const Subheading = tw.span`uppercase tracking-wider text-sm`;
export default ({ roundedHeaderButton }) => {
  return (
    <AnimationRevealPage>
        <SEO
title="Healthcare Page" 
description="Healthcare Page"
/>
      <TwoColumnWithVideo
       heading="Comprehensive Healthcare IT Solutions and Services for Enhanced Care Delivery"
       buttonRounded={false}
       primaryButtonText="Request free consultation"
       primaryButtonUrl = "https://calendly.com/solutions-tbnw/30min?month=2024-11"
       description="MetroMidas provides a full suite of Healthcare IT services, including consulting, development, support, and ongoing upgrades & maintenance. We deliver secure, innovative, and cost-effective solutions designed to meet the dynamic needs of the healthcare industry, ensuring adaptability to ever-changing requirements and regulations."
       imageSrc={Healthcare4}
       />

<MainFeature1
        subheading={<Subheading></Subheading>}
        heading="A Reliable Partner for Comprehensive Healthcare IT Solutions"
        buttonRounded={false}
        primaryButtonText="Contact Us"
        primaryButtonUrl = "/contactus"
        description="Metromidas offers end-to-end healthcare IT services, from strategic planning and software development to system modernization and ongoing IT support, ensuring seamless management of medical technology."
        imageSrc={Healthcare2}
        textOnLeft={false}
      />
       <GetStarted />

<TwoColContactUsWithIllustrationFullForm />
      <Footer />
    </AnimationRevealPage>
    
  );
};
